export default {"src":"/_next/static/media/usdc.3e92b3cf.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};